module.exports = __webpack_public_path__ + "static/media/localTransferIcon.76dc5e5a.svg";